import { z } from 'zod';
import { requiredString } from '../helpers';
/**
 * Webhook Webhook v1 Configuration Validator
 * Validates webhook configuration including URL, secret, and payload
 */
export const Webhook_Webhook_1_ConfigValidator = z.object({
    url: requiredString('Webhook URL is required'),
    secret: z.string().optional(),
    payload: z.record(z.string(), z.any()).optional()
});
//# sourceMappingURL=webhook-webhook-1.js.map